import { configureStore } from '@reduxjs/toolkit';
import { authApi } from '../features/auth/authApi';
import { sliderApi } from '../features/slider/sliderApi';
import { tipSliderApi } from '../features/slider/tipSliderApi';
import { sizeApi } from '../features/size/sizeApi';
import authReducer from '../features/auth/authSlice';
import { colorApi } from '../features/color/colorApi';
import { categoryApi } from '../features/category/categoryApi';
import { menuApi } from '../features/MenuApi';
import { productApi } from '../features/product/productApi';
import { contactApi } from '../features/contact/contactApi';
import { socialApi } from '../features/social/socialApi';
import { homeApi } from '../features/home/homeApi';
import { optionApi } from '../features/option/optionApi';
import { typeApi } from '../features/type/typeApi';
import { providerApi } from '../features/provider/providerApi';
import { placeApi } from '../features/place/placeApi';
import { commentApi } from '../features/comment/commentApi';
import { couponApi } from '../features/coupon/couponApi';
import { orderApi } from '../features/order/orderApi';
import { branchApi } from '../features/branch/branchApi';
import { supportApi } from '../features/support/supportApi';
import cartReducer from '../features/cart/cartSlice';
import favoritesReducer from '../features/favorites/favoritesSlice';
import uiReducer from '../features/ui/uiSlice';
import sessionReducer from '../features/session/sessionSlice';

export const store = configureStore({
  reducer: {
    [menuApi.reducerPath]: menuApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [sliderApi.reducerPath]: sliderApi.reducer,
    [tipSliderApi.reducerPath]: tipSliderApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [sizeApi.reducerPath]: sizeApi.reducer,
    [colorApi.reducerPath]: colorApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
    [socialApi.reducerPath]: socialApi.reducer,
    [optionApi.reducerPath]: optionApi.reducer,
    [typeApi.reducerPath]: typeApi.reducer,
    [providerApi.reducerPath]: providerApi.reducer,
    [placeApi.reducerPath]: placeApi.reducer,
    [commentApi.reducerPath]: commentApi.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    homeApi: homeApi.reducer,
    auth: authReducer,
    cart: cartReducer,
    favorites: favoritesReducer,
    ui: uiReducer,
    session: sessionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(menuApi.middleware)
      .concat(authApi.middleware)
      .concat(sliderApi.middleware)
      .concat(tipSliderApi.middleware)
      .concat(categoryApi.middleware)
      .concat(sizeApi.middleware)
      .concat(colorApi.middleware)
      .concat(productApi.middleware)
      .concat(contactApi.middleware)
      .concat(socialApi.middleware)
      .concat(optionApi.middleware)
      .concat(typeApi.middleware)
      .concat(providerApi.middleware)
      .concat(placeApi.middleware)
      .concat(commentApi.middleware)
      .concat(couponApi.middleware)
      .concat(orderApi.middleware)
      .concat(branchApi.middleware)
      .concat(supportApi.middleware)
      .concat(homeApi.middleware),
});
